import add from "./js/calculator"

console.log(add(2, 3));


import {calculator, math} from "./js/calculator"

console.log(calculator(3, 7));
console.log(math(966, 1));





// import copy from "./js/calculator"
// console.log(copy);
// console.log(copy.calc(12, 13));
// console.log(copy.m(1000, 500));

